import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import classNames from "classnames";
import { useStoreLocatorContext } from "../../../../components/StoreLocator/hooks";
import { useTranslations } from "../../../../providers/useTranslations";
import styles from "./StoreLocatorCount.module.scss";
export const StoreLocatorCount = (props) => {
    const { __ } = useTranslations();
    const { flotiqStores, isNoMatchingFlotiqStores } = useStoreLocatorContext();
    const storesCount = useMemo(() => flotiqStores?.length || 0, [flotiqStores]);
    if (isNoMatchingFlotiqStores) {
        return null;
    }
    return (_jsxs("div", { className: classNames(styles.countLabel, props.className), "aria-live": "polite", children: [__("storelocator.stores_count"), " ", _jsx("span", { "aria-label": "Number of stores found", children: storesCount })] }));
};
//# sourceMappingURL=StoreLocatorCount.js.map